export default class SignedOutError extends Error {
  constructor() {
    super('ログインが必要です')
    this.name = 'SignedOutError'
  }
}
